import PropTypes from 'prop-types';

function MMBeveragesActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11307)">
                <path
                    d="M2.76382 5.34114L2.42072 2.94419L13.0759 1.69092L13.5525 3.80671L2.76382 5.34114Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.76389 5.3457C2.76389 5.3457 1.63451 8.91491 1.71552 10.4112C1.79653 11.9075 4.2173 28.0095 4.27449 28.3955C4.33167 28.7814 8.02478 29.8918 8.02478 29.8918C8.02478 29.8918 7.10984 14.1091 5.49917 9.27708C5.10842 8.09528 2.76389 5.3457 2.76389 5.3457Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.76385 5.34549C2.76385 5.34549 4.80817 8.20467 5.1465 9.7248C5.48484 11.2449 7.62922 29.944 8.00568 29.8915C8.38214 29.8391 18.923 26.9371 18.9659 26.6845C19.0088 26.4319 16.6976 9.32451 16.4021 8.64308C16.1067 7.96164 13.7431 3.77771 13.543 3.8063L2.76385 5.34549Z"
                    fill="#DFA455"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.03425 17.888L8.61085 21.9528C8.63051 22.0907 8.67846 22.223 8.7517 22.3415C8.82494 22.4599 8.92189 22.562 9.03645 22.6412C9.151 22.7204 9.2807 22.775 9.4174 22.8017C9.55409 22.8284 9.69483 22.8265 9.83077 22.7962L15.816 21.4763C16.06 21.4225 16.2753 21.2802 16.4206 21.0769C16.5658 20.8736 16.6305 20.6237 16.6023 20.3755L16.1257 16.2726C16.1105 16.1313 16.0655 15.9949 15.9937 15.8724C15.9219 15.7498 15.825 15.6438 15.7093 15.5614C15.5936 15.479 15.4617 15.4221 15.3224 15.3944C15.1831 15.3666 15.0395 15.3687 14.901 15.4005L8.81099 16.7824C8.56787 16.8383 8.35401 16.9821 8.21061 17.1863C8.0672 17.3904 8.00438 17.6403 8.03425 17.888V17.888Z"
                    fill="#2D2D2D"
                />
                <path
                    d="M21.8997 21.5475L25.1519 21.3006C26.4137 21.1971 27.6261 20.7641 28.6679 20.0449C29.6432 19.3877 29.8943 17.5628 29.8441 16.2778C29.8568 15.7333 29.757 15.1921 29.551 14.688C29.345 14.1838 29.0373 13.7276 28.647 13.3478C27.6801 12.406 26.7634 12.3181 25.7714 12.1507C24.7794 11.9833 21.1672 12.3558 21.1672 12.3558L21.343 14.051C21.9708 13.9715 24.951 13.3855 26.4579 13.9547C27.9647 14.524 28.3456 15.3946 28.1782 17.3033C28.0484 18.7766 26.2863 19.35 25.0222 19.4463L21.7825 19.6975L21.8997 21.5475Z"
                    fill="#F1C34B"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.5652 9.36719C22.5652 9.36719 23.1177 14.0593 23.2475 15.7587C23.3773 17.4581 23.4819 19.4965 23.5028 20.363C23.5028 21.0494 23.8628 23.1632 23.6451 23.5231C23.4275 23.8831 21.6821 25.2811 17.2452 25.3774C12.8084 25.4737 11.6699 25.1681 11.423 24.5026C11.176 23.8371 11.1048 20.3169 10.8663 17.2279L10.3389 10.3006L22.5652 9.36719Z"
                    fill="#F1C34B"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.6472 10.8551C20.0338 10.5842 22.7408 9.88484 22.6935 9.29305C22.6462 8.70126 19.8624 8.44115 16.4758 8.71208C13.0891 8.983 10.3821 9.68238 10.4295 10.2742C10.4768 10.866 13.2606 11.1261 16.6472 10.8551Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.3186 10.899C11.6782 10.6269 14.7715 10.0619 15.7969 9.98652C16.8224 9.91118 18.7604 9.72701 19.4636 9.88606C19.9114 9.99775 20.3518 10.1376 20.7821 10.3046C19.9941 10.5054 19.1945 10.6578 18.3879 10.7609C17.647 10.7944 13.0386 11.2087 12.3186 10.899Z"
                    fill="#2D2D2D"
                />
                <path
                    d="M17.7541 6.15326C17.9691 5.94417 18.1087 5.66972 18.1511 5.37284C18.1936 5.07596 18.1364 4.77339 17.9885 4.51247C17.6969 4.05226 17.4608 3.55909 17.2853 3.0433C17.264 2.58727 17.4132 2.13964 17.7039 1.7876"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.3239 6.03191C19.5414 5.75078 19.6758 5.4144 19.7121 5.06082C19.7483 4.70724 19.6849 4.35057 19.529 4.03116C19.2251 3.45777 18.9811 2.85465 18.8007 2.23132C18.7553 1.68622 18.8923 1.1415 19.1899 0.682617"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11307">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.287109)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMBeveragesActive;

MMBeveragesActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMBeveragesActive.defaultProps = {
    className: null,
};
